<template>
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
						$t('back')
					}}
				</b-button>
			</div>
			<div class="pull-right">
				<b-button variant="outline-dark" @click="print" class="mr-2"
						  v-if="item.documentStatus !== 'SUSPENDED' && item.documentStatus !== 'WAITING_FOR_READY'">
					<i class="fa fa-print"></i>
					{{ $t('Печать') }}
				</b-button>
			</div>
			<div class="clearfix"></div>
		</div>
		<div class="doc-body">
			<b-card>
				<table style="width: 100%">
					<thead class="mb-3">
					<tr>
						<th>
							<div class="row">
								<div class="col-md-4">
									<b>CentralAsia Megastar</b>
								</div>
								<div class="col-md-4">
									<p class="text-center">
										Накладная передачи
									</p>
								</div>
								<div class="col-md-2">
									<p id="currentDate" style="text-align: right; font-size: 11px" class="float-right">
										{{ currentDate }}</p>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-md-4">
									<table>
										<tr>
											<td>Номер</td>
											<td><b>{{ item.regNumber }}</b></td>
											<td>Откуда</td>
											<td><b>{{ item.fromDepartmentName }}</b></td>
										</tr>
										<tr>
											<td>Дата</td>
											<td><b>{{ item.regDate }}</b></td>
										</tr>
									</table>
								</div>
								<div class="col-md-2"></div>
								<div class="col-md-6">
									<div class="row">
										<div class="col-4">
											<span>Кем создано:</span>
											&nbsp;&nbsp;<span>{{ item.docCreatedBy }}</span>
										</div>
										<div class="col-8">
											<span>Время создания:</span>&nbsp;&nbsp;<span>{{
												item.docCreatedDate
											}}</span>
										</div>
									</div>
								</div>
							</div>
						</th>
					</tr>
					</thead>
					<tbody>
					<tr style="vertical-align: middle">
						<td>
							<div class="mb-3" id="nakladnoyTableWrapper">
								<b-table :items="item.whItems" class="text-center" id="gridContainer" :fields="fildes"
										 foot-clone hover striped bordered label-sort-asc="" label-sort-desc=""
										 label-sort-clear="">
									<template #cell(index)="data">
										{{ data.index + 1 }}
									</template>
									<template #cell(multiBarcodes)="data">
										<p v-for="(barcode, k) in data.item.multiBarcodes" :key="k">
											{{ barcode.barcode }}
										</p>
									</template>
									<template #cell(unitName)="data">
										{{ data.item.count }} <sup>{{ data.item.unitName }}</sup>
									</template>
									<template #cell(priceUzs)="data">
										{{
											data.item.priceUzs | currency({
												symbol: ' ', fractionCount: 2, symbolPosition: 'back'
											})
										}}
									</template>
									<template #cell(fractionCount)="data">
										<span class="text-center">{{
												(data.item.priceUzs * data.item.count) | currency({
													symbol: ' ', fractionCount: 2, symbolPosition: 'back'
												})
											}}</span>
									</template>


									<template #foot(index)="data">
										{{ "" }}
									</template>
									<template #foot(barcode)="data">
										{{ "" }}
									</template>
									<template #foot(itemName)="data">
										{{ "" }}
									</template>
									<template #foot(multiBarcodes)="data">
										{{ "Итого" }}
									</template>
									<template #foot(unitName)="data">
										<span v-if="totalCountItems > 0" style="font-weight: bold">
									{{ totalCountItems }}
								</span>
									</template>
									<template #foot(priceUzs)="data">
										{{ "" }}
									</template>
									<template #foot(fractionCount)="data">
										<span v-if="totalPriceOfItems > 0" style="font-weight: bold">{{
												totalPriceOfItems | currency({
													symbol: ' ',
													fractionCount: 2,
													symbolPosition: 'back'
												})
											}}</span>
									</template>

								</b-table>
								<b-button class="float-right mt-1 exs hidden-print"
										  v-if="item.whItems&&item.whItems.length > 0"
										  @click="excelExport1('gridContainer', ' Приходная накладная')"
										  variant="primary">{{ $t('excel-export.download-excel') }}
								</b-button>
								<div v-if="loader" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</td>
					</tr>
					</tbody>
					<tfoot class="nakladnoyFooter">
					<tr>
						<td>
							<table style="width: 100%;">
								<tr v-for="(i, indx) in item.qrCodes">
									<th width="10">
										<b>{{ i.signe }}</b>
									</th>
									<th>
										<QrcodeVue :ref="`qrcodeRef${indx}`" :value="i.qrCode" size="50" level="L"/>
									</th>
									<th>
										{{ `${splitTotal[indx][0]} ${splitTotal[indx][1]}` }}
									</th>
									<th></th>
									<th></th>
									<th></th>
									<th></th>
								</tr>
								<br>
								<tr>
									<td>Сотрудник т/п №1 СТК "Ташкент АЭРО"</td>
									<td colspan="2" class="text-right">______________________________</td>
									<td colspan="2">______________________________</td>
								</tr>
								<tr>
									<td></td>
									<td colspan="2" class="text-center">Ф.И.О</td>
									<td class="text-center">
										подпись
									</td>
								</tr>
							</table>
						</td>
					</tr>
					</tfoot>
				</table>
				<!--				<pre>-->
				<!--					{{item}}-->
				<!--				</pre>-->

			</b-card>
		</div>
		<b-modal :title="$t('barcode-count')"
				 v-model="confirmBarcodeGenerate"
				 size="lg"
		>

			<table class="table table-bordered mt-3" style="margin-right: 10px;margin-left: 10px;">

				<tr>
					<th>&#9745;</th>
					<th style="width: 30px;text-align: center">№</th>
					<th>{{ $t('sidebar.warehouse-management.products') }}</th>
					<th colspan="2">{{ $t('goods.amount') }}</th>
					<!--<th style="width: 230px;">Количество</th>-->
				</tr>

				<tr cols="12" v-for="(calculateCount,index) in currentWhItems">
					<td>
						<b-checkbox v-model="calculateCount.checked"></b-checkbox>
					</td>
					<td style="text-align: center">
						{{ index + 1 }}
					</td>
					<td>{{ calculateCount.itemName }} / <strong> {{ calculateCount.artikul }} </strong>/
						{{ calculateCount.color }} /{{ calculateCount.size }}
						<strong>{{ calculateCount.barcode }}</strong></td>
					<td>
						<b-col>
							<b-input-group size="sm">
								<b-form-input v-model="calculateCount.count"
											  size="sm" autocomplete="off" type="number"
											  :disabled="!calculateCount.checked"
								></b-form-input>
							</b-input-group>
						</b-col>
					</td>
				</tr>
			</table>

			<div slot="modal-footer">
				<b-button
					variant="success"
					size="sm"
					class="float-right ml-2"
					@click="submitBarcodeGenerate"
				>
					{{ $t('save') }}
				</b-button>

				<b-button
					variant="primary"
					size="sm"
					class="float-right"
					@click="cancelBarcodeGenerate"
				>
					{{ $t('cancel') }}
				</b-button>
			</div>
		</b-modal>
		<b-modal v-model="pricePrint" size="lg" :title="$t('incomes.create.prices')">

			<b-table
				:items="priceWhItems"
				:fields="priceCols"
				selectable
				ref="priceSelectedItems"
			>
				<template slot="index" slot-scope="data">
					{{ data.index + 1 }}
				</template>
				<template slot="multiBarcodesString" slot-scope="data">
					<div v-for="barcode in data.item.multiBarcodesString">
						{{ barcode }}
					</div>
				</template>
			</b-table>

			<div slot="modal-footer">
				<b-button
					variant="success"
					size="sm"
					class="float-right ml-2"
					@click="submitPricePrint"
				>
					{{ $t('save') }}
				</b-button>

				<b-button
					variant="primary"
					size="sm"
					class="float-right"
					@click="pricePrint = false"
				>
					{{ $t('cancel') }}
				</b-button>
			</div>
		</b-modal>
	</div>

</template>

<script>
import {BTable, VBTable} from "bootstrap-vue";
import {mapActions} from 'vuex'
import WhDocument from "@/services/wh-document.service";
import QrcodeVue from "qrcode.vue";
import MaskedInput from 'vue-masked-input'

export default {
	name: 'discountRefuseView',
	render(h) {
		return h(this.tag, this.is)
	},
	data() {
		return {
			eimzoData: [],
			qrcodeValue: 'salom',
			currentDate: '',
			pricePrint: false,
			changePrice: false,
			showUpperPartOfDoc: true,
			seriaBarcodeConfirmed: false,
			seriaForBarcodeGenerate: '',
			root_api: process.env.VUE_APP_ROOT_API,
			vatPercentage: null,
			is: {type: String, required: true},
			loader: false,
			item: {},
			totalPrice: {
				uzs: 0,
				usd: 0,
				saleTypePrice: 0,
			},
			priceType: 'uzs',
			income: [],
			totalIncome: {
				uzs: 0,
				usd: 0
			},
			fildes: [
				{key: 'index', label: '№', class: 'text-center font-sm', visible: true},
				{key: 'barcode', label: "Спец-код", class: 'text-center font-sm', visible: true, sortable: true},
				{key: 'itemName', label: "Наименование", class: 'text-center font-sm', visible: true, sortable: true},
				{key: 'multiBarcodes', label: "Штрих-код", class: 'text-center font-sm', visible: true, sortable: true},
				{key: 'unitName', label: "Кол-во", class: 'text-center font-sm', visible: true, sortable: true},
				{key: 'priceUzs', label: "Цена", class: 'text-center font-sm', visible: true, sortable: true},
				{key: 'fractionCount', label: "Сумма", class: 'text-center font-sm', visible: true, sortable: true},
			],
			confirmBarcodeGenerate: false,
			barcodeCount: 0,
			currentWhItems: [],
			priceWhItems: [],
			priceCols: [
				{key: 'index', label: '№', class: 'text-center'},
				{key: 'barcode', label: this.$t('goods.name')},
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center'},
				{key: 'multiBarcodesString', label: this.$t('goods.barcode'), class: 'text-center'},
				{key: 'priceUzs', label: this.$t('incomes.create.price'), class: 'text-center'}
			],
			// sidebar: {
			//   open: false,
			//   close: false
			// },
			backTo: null,
			tag5: 'span',
			tag6: 'span',
			tag7: 'span',
			tag4: 'span',
			tag81: 'span',
			tag82: 'span',
			tag83: 'span',
			tag9: 'span',
			tagNdsTranspartor: 'span',
			tag31: 'span',
			tag32: 'span',
			tag33: 'span',
			tag0101: 'span',
			tag0202: 'span'
		}
	},

	methods: {
		printPdf() {
			window.print();
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function (s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function (s, c) {
					return s.replace(/{(\w+)}/g, function (m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		resetSeriaBarcodeInput() {
			this.seriaBarcodeConfirmed = false;
		},
		generateBarcodeForSeria($event) {
			if ($event.target.value.trim() == '') {
				return 0;
			}
			this.seriaForBarcodeGenerate = $event.target.value
			this.seriaBarcodeConfirmed = true;
		},
		async excelNakladnoyApi() {
			await WhDocument.excelNakladnoyTransfer(this.$route.params.id)
		},
		// openSidebar() {
		//   setTimeout(() => {
		//     this.sidebar.open = true
		//   }, 200)
		// },
		...mapActions('warehouse', [
			'setCurrentWhItems', 'setPriceWhItems'
		]),
		cancelBarcodeGenerate() {
			this.confirmBarcodeGenerate = false;
		},
		submitBarcodeGenerate() {
			let items = {};
			items.status = true;
			items.data = this.currentWhItems.filter(column => column.checked === true);
			items.data.forEach((item, index) => {
				items.data[index].count = parseInt(item.count)
			});
			this.setCurrentWhItems(items);
			this.$router.push(`/warehouse-management/income/barcodes`);
		},
		generateBarcode() {
			//this.currentWhItems = Object.assign({}, this.item.whItems);
			this.currentWhItems = JSON.parse(JSON.stringify(this.item.whItems));
			this.confirmBarcodeGenerate = true;
			//this.$router.push(`/warehouse-management/income/barcodes/${this.$route.params.id}`);

		},
		generatePrice() {
			this.priceWhItems = JSON.parse(JSON.stringify(this.item.whItems));
			this.pricePrint = true
		},
		getCurrentDate() {
			var today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0');
			var yyyy = today.getFullYear();
			let hours = new Date().getHours(),
				minutes = new Date().getMinutes(),
				seconds = new Date().getSeconds();
			hours = hours.toString().length === 1 ? `0${hours}` : `${hours}`
			minutes = minutes.toString().length === 1 ? `0${minutes}` : `${minutes}`
			seconds = seconds.toString().length === 1 ? `0${seconds}` : `${seconds}`
			this.currentDate = `${dd}-${mm}-${yyyy} ${hours}:${minutes}:${seconds}`
			return true;
		},
		submitPricePrint() {
			let items = {};
			items.status = true;
			items.data = JSON.parse(JSON.stringify(this.item.whItems));
			items.data.forEach((item, index) => {
				items.data[index].count = parseInt(item.count)
			});
			this.setPriceWhItems(items);
			this.$router.push(`/warehouse-management/price/print`);
		},
		get() {
			if (this.$can('get', 'warehouse-document')) {
				this.loader = true;
				return WhDocument.get(this.$route.params.id).then(response => {
					this.loader = false;
					this.item = response.data;
					this.sumPrice(this.item);
					this.sumIncome(this.item);
				}).catch(error => {
					this.loader = false
				})
			}
		},
		sumPrice(item) {
			if (typeof item.whItems === 'object') {
				Object.values(item.whItems).map(item => {
					if (item.priceUsd) this.totalPrice.usd += item.priceUsd * item.count;
					if (item.priceUzs) this.totalPrice.uzs += item.priceUzs ? item.priceUzs * item.count : 0;
					if (item.saleTypePrice) this.totalPrice.saleTypePrice += item.saleTypePrice ? item.saleTypePrice * item.count : 0;
				});
			}
		},
		sumIncome(item) {
			if (typeof item.whItems === 'object') {
				Object.values(item.whItems).map(item => {
					this.totalIncome.usd += item.incomingPriceUsd * item.count;
					this.totalIncome.uzs += item.incomingPriceUzs ? item.incomingPriceUzs * item.count : 0;
				});
			}
		},
		goBackToFrom() {
			this.$router.back();
		},
		async print() {
			Object.keys(this.$refs).filter(key => key.startsWith('qrcodeRef')).forEach(key => {
				const {$el} = this.$refs[key][0]
				const image = $el.querySelector('canvas').toDataURL()
				$el.innerHTML = `<img src="${image}" />`;

			})
			this.getCurrentDate();

			setTimeout(window.print, 500)
		},
		tableToExcel(tableID) {
			var tab_text = "<table border='2px'><tr bgcolor='#87AFC6'>";
			var textRange = "<p text-align=''";
			var j = 0;
			let tab = document.getElementById(tableID); // id of table

			for (j = 0; j < tab.rows.length; j++) {
				tab_text = tab_text + tab.rows[j].innerHTML + "</tr>";
				//tab_text=tab_text+"</tr>";
			}

			tab_text = tab_text + "</table>";
			tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
			tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
			// tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

			var ua = window.navigator.userAgent;
			var msie = ua.indexOf("MSIE ");

			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer
			{
				txtArea1.document.open("txt/html", "replace");
				txtArea1.document.write(tab_text);
				txtArea1.document.close();
				txtArea1.focus();
				var sa = txtArea1.document.execCommand("SaveAs", true, "Say Thanks to Sumit.xls");
			} else                 //other browser not tested on IE 11
				sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));

			return (sa);
		},
		excelExport(tableID, filename = '') {

			let downloadLink;

			let dataType = 'text/xls;charset=UTF-8';
			//var dataType = 'application/vnd.ms-excel';
			let tableSelect = document.getElementById(tableID);
			let tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename.length > 0 ? filename + '.xls' : 'excel_data.xls';
			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if (navigator.msSaveOrOpenBlob) {
				let blob = new Blob(['\ufeff', tableSelect], {
					encoding: "utf-8",
					type: dataType
				});
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				// Create a link to the file
				downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

				// Setting the file name
				downloadLink.download = filename;

				//triggering the function
				downloadLink.click();
			}
		},
		calculateRealCostOfItem(item) {
			/*let sumOfPriceWithoutNds = (item.priceWholesale/1.2) * item.count;
			let sumOfNds = ((item.priceWholesale * item.count) * 0.2)/1.2;*/
			if (this.changePrice) {
				if (item.priceUzs == item.saleTypePrice) {
					if (item.priceWholesale > 0) {
						return item.priceWholesale * item.count;
					} else {
						return 0;
					}
				} else {
					if (item.priceUzs > 0) {
						return item.priceUzs * item.count;
					} else {
						return 0;
					}
				}
			} else {
				if (item.saleTypePrice > 0) {
					return item.saleTypePrice * item.count;
				} else {
					return 0
				}
			}
		},
		calculateNdsOfItem(item) {
			return this.calculateRealCostOfItem(item) / 6;
		},
		calculateSumOfItemWithoutNds(item) {
			return this.calculateRealCostOfItem(item) - this.calculateNdsOfItem(item);
		},
		calculatePriceWithoutNds(item) {
			return this.calculateSumOfItemWithoutNds(item) / item.count;
		},
		calculateTotalRealCost() {
			let temp = 0;
			if (this.item.whItems) {
				for (let i = 0; i < this.item.whItems.length; i++) {
					temp += this.calculateRealCostOfItem(this.item.whItems[i]);
				}
			}
			return temp;
		}
	},
	async created() {
		this.getCurrentDate();
		await this.get()
		// await this.getDepartmentInfo('toDep');
		// await this.getDepartmentInfo('fromDep');
	},
	computed: {
		totalPriceOfItems() {
			let temp = 0;
			if (this.item.whItems) {
				this.item.whItems.forEach(el => {
					temp += (el.priceUzs * el.count);
				});
			}
			return temp;
		},
		totalCountItems() {
			let temp = 0;
			if (this.item.whItems) {
				this.item.whItems.forEach(el => {
					temp += el.count;
				});
			}
			return temp;
		},
		splitTotal() {
			let temp = [];
			this.item.qrCodes.map(ind => {
				temp.push(ind.qrCode.split(' ', 3))
			})
			return temp
		},
		totalNdsOfItems() {
			let temp = 0;
			if (this.item.whItems) {
				this.item.whItems.forEach(el => {
					temp += this.calculateNdsOfItem(el);
				});
			}
			return temp;
		}
	},
	components: {
		MaskedInput,
		QrcodeVue,
		VBTable,
		BTable
	},
}
</script>

<style scoped>

</style>
<style scoped lang="scss">

@page {
	margin: 1cm;
}

#currentDate {
	display: none;
}


.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}

.nakladnoyWholesale {
	margin: 0 20px;
}

@media print {
	.hidden-print {
		display: none;
	}
	.col-md-8 {

	}
	#currentDate {
		display: inline-table;
		position: absolute;
		right: -150px;
	}
	.mt {
		padding-top: 200px !important;
	}
	.card {
		box-shadow: none;
	}
	#nakladnoyTableWrapper {
		display: block;
	}
}

.saldoInfoTexts {
	width: 88%;

	span {
		display: inline-block;
		width: 18%;
	}

	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 80%;
	}

	// input.bottomBorderedInput:focus {
	// border-color: green
	// }
}


.signsOfAccountants {
	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 40%;
	}

	p {
		width: 40%;

		&.sign {
			text-align: center;
			font-size: 12px;
		}
	}
}

input.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

h6.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

#nakladnoyTableWrapper {
	.table {
		td, th {
			border: 1px solid black;
			vertical-align: middle;

			&.borderRightNone {
				border-right: none;
			}

			&.borderLeftNone {
				border-left: none;
			}

			&.borderTopNone {
				border-top: none;
			}

			&.borderBottomNone {
				border-bottom: none;
			}

			color: black;
		}

		#moldavianItemsHeader {
			th {
				font-size: 9px;
				border-bottom: none;
			}

			.width27 {
				width: 27%;
			}
		}

		#russianItemsHeader {
			th {
				font-size: 9px;
				border-top: none;
			}

			.greyText {
				color: #999999;
			}
		}

		.docItemRow {
			td {
				padding: 0 .5rem;
			}
		}

		th {
			font-size: 14px;
		}

		td {
			font-size: 13px !important;
		}


		.moldavianText {
			font-weight: bold;
		}

		.fontWeightNormal {
			font-weight: normal;
		}

		.nakladnoyFooter {
			margin-top: 15px !important;
		}

		tfoot {
			margin-top: 15px !important;
		}
	}
}

.customSize {
	font-size: 10px;
}

.customSizeItem {
	font-size: 12px;
}

.nobr {
	white-space: nowrap;
}

.strong {
	font-weight: bold;
}

#docUpperPart {
	p {
		margin-bottom: 0;
	}

	margin-bottom: .5rem;

	#docImgLogoName {
		margin-left: 32%;
		width: 300px;
		height: auto;
	}

	#docImgLogo {
		width: 180px;
		height: 70px;
	}

	#docUpperPartLeft {
		#docUpperPartTxt {
			margin-top: .5rem;
			display: inline-block;
			width: 30%;

			p {
				display: inline-block;
			}
		}

		#barcodeImgForSeria {
			cursor: pointer;
			display: inline-block;
			width: 30%;

			svg {
				vertical-align: bottom;
				width: 46mm !important;
				height: auto !important;

				g {
					text {
						font-size: 14px !important;
						transform: translateY(46px) !important;
					}
				}
			}
		}

		display: inline-block;
		width: 74%;

		#seriaInputForBarcode {
			display: inline-block;

			input {
				margin-left: .5rem;
				width: 10rem;
				height: 1.2rem;
			}
		}
	}

	#docUpperPartRight {
		display: inline-block;
		width: 26%;
		vertical-align: top;
		text-align: right;

		#rightPartTxt {
			font-size: 10px;
		}
	}
}
</style>
